export default __webpack_public_path__ + "static/media/icon_bandstyle_HalfRound.755b344d.png";